import { useState, ReactNode } from 'react';
import styles from './DemoWrapper.module.css';

interface DemoWrapperProps {
  children: ReactNode;
  /** Shown in the frame header next to the sparkle */
  title?: string;
  /** Small mono chip on the right, e.g. the interface type */
  chip?: string;
}

/** Frosted demo frame matching the landing-page hero demo. Reset remounts the demo. */
export function DemoWrapper({ children, title = 'Try the pattern', chip }: DemoWrapperProps) {
  const [key, setKey] = useState(0);

  return (
    <div className={styles.stage}>
      <div className={styles.glow} aria-hidden="true">
        <span />
        <span />
        <span />
      </div>
      <div className={styles.frame}>
        <div className={styles.head}>
          <div className={styles.title}>
            <span className={styles.spark} aria-hidden="true">✦</span>
            {title}
          </div>
          <div className={styles.headRight}>
            {chip && <span className={styles.chip}>{chip}</span>}
            <button type="button" className={styles.reset} onClick={() => setKey((k) => k + 1)}>
              Reset
            </button>
          </div>
        </div>
        <div key={key} className={styles.body}>
          {children}
        </div>
      </div>
    </div>
  );
}
